/* eslint-disable */
import React from "react"
import "./Table.scss"

const Table = ({ className, children, ...props }) => {
  return (
    <div className="table-wrap">
      <table className={`table ${className ? className : ""}`} {...props}>
        {children}
      </table>
    </div>
  )
}

Table.propTypes = {}

Table.defaultProps = {}

export default Table
